import { DateRangeFilterPanel } from './panels/date-range-panel';
import { EntityFilterPanel } from './panels/entity-filter-panel';
import { SimpleFilterPanel } from './panels/simple-filter-panel';
import { FILTER_KIND, type TFilterConfig } from '../../types/filter-config';

export const ConditionallyRenderedFilterPanel = ({
  config,
}: {
  config: TFilterConfig;
}) => {
  switch (config.kind) {
    case FILTER_KIND.simple:
      return <SimpleFilterPanel config={config} />;

    case FILTER_KIND.entity:
      return <EntityFilterPanel config={config} />;

    case FILTER_KIND.dateRange:
      return <DateRangeFilterPanel config={config} />;

    default:
      return null;
  }
};
